import React, {useEffect, useState} from "react";
import { MagnifyingGlassIcon, XMarkIcon } from "@heroicons/react/24/solid";
import {classNames} from "../../common/util/util-helpers";

export default function FieldTextSearch({ item, onChange, }) {
    if (!item.props) {
        item.props = {}
    }

    if (!item.metadata) {
        item.metadata = {}
    }

    const [inputValue, setInputValue] = useState(undefined);

    const submitChange = () => onChange(item.name, inputValue);

    const onSearchChange = (event) => {
        setInputValue(event.target.value);
    }

    useEffect(() => {
        if (!item.value && !!inputValue) {
            setInputValue("");
        }
    }, [item.value])

    useEffect(() => {
        let debounceTimeout;
        if (inputValue !== undefined && item.value !== inputValue) { // prevent submitting on initial load
            debounceTimeout = setTimeout(submitChange, 300);
        }

        if (inputValue === undefined && item.value) {
            setInputValue(item.value)
        }

        return () => {
            clearTimeout(debounceTimeout);
        }
    }, [inputValue])

    const input = (
        <input
            id={item.props.id}
            type={item.type}
            readOnly={item.props.readOnly}
            autoFocus={item.props.autoFocus}
            onChange={onSearchChange}
            onKeyDown={item.metadata.onKeyDown}
            name={item.name}
            value={inputValue}
            placeholder={item.props.placeholder}
            disabled={item.disabled}
            className={classNames("form-control pl-10", item.metadata.addClass)}
            min={item.props.min}
            maxLength={item.props.max}
            step={item.props.step}
            autoComplete={item.props.autocomplete}
        />);

    return (
        <React.Fragment>
            <div className="relative w-full">
                <div
                    className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <MagnifyingGlassIcon className="w-5 h-5 text-tm-gray-400 z-10"/>
                </div>

                {!!item.value && (
                    <button
                        onClick={() => onChange(item.name, "")}
                        className="absolute z-10 inset-y-0 right-0 px-3 flex items-center cursor-pointer text-tm-gray-900 hover:text-tm-gray-400">
                        <XMarkIcon className="w-4 h-4"/>
                    </button>
                )}

                {input}
            </div>
        </React.Fragment>

    )
}
